/** 금액을 릴 슬롯(숫자 + 콤마) 배열로 변환 */
export const JACKPOT_REEL_CELL_H = 28

export function getDigitAtPower (amount, power) {
  const str = String(Math.max(0, Math.floor(Number(amount) || 0)))
  const idx = str.length - Number(power) - 1
  if (idx < 0 || idx >= str.length) return 0
  return Number(str[idx]) || 0
}

/** 변경된 자릿수만 오른쪽→왼쪽 순서로 릴 지연(ms) 계산 */
export function getChangedDigitSpinPlan (prevAmount, nextAmount, stepMs = 110) {
  const prev = Math.max(0, Math.floor(Number(prevAmount) || 0))
  const next = Math.max(0, Math.floor(Number(nextAmount) || 0))
  const maxLen = Math.max(String(prev).length, String(next).length)
  const changed = []

  for (let power = 0; power < maxLen; power++) {
    if (getDigitAtPower(prev, power) !== getDigitAtPower(next, power)) {
      changed.push(power)
    }
  }

  changed.sort((a, b) => a - b)

  const plan = {}
  changed.forEach((power, idx) => {
    plan[power] = {
      delay: idx * stepMs,
      from: getDigitAtPower(prev, power),
      to: getDigitAtPower(next, power)
    }
  })
  return plan
}

export function amountToDisplaySlots (amount) {
  const num = Math.max(0, Math.floor(Number(amount) || 0))
  const str = String(num)
  const len = str.length
  const slots = []

  for (let i = 0; i < len; i++) {
    const power = len - i - 1
    slots.push({
      type: 'digit',
      value: Number(str[i]),
      id: `p${power}`
    })
    const remaining = len - i - 1
    if (remaining > 0 && remaining % 3 === 0) {
      slots.push({
        type: 'comma',
        id: `c-p${power}`
      })
    }
  }

  return slots
}
